import CustaDestinatario  from "@/entities/CustaDestinatario/CustaDestinatario"

const selosFisicos = ['RA', 'AU', 'S1', 'S2', 'C1', 'C2']

class Custa {
  constructor (data) {
    this.custa_id = null
    this.delta_custa_item_id = null
    this.codigo = null
    this.cartorio_id = null
    this.custa_info_iss_id = null
    this.ato = null
    this.descricao_simplificada_ato = null
    this.tipo_ato = null
    this.tipo_selo = null
    this.selo_duplo = null
    this.impresso_seguranca = null
    this.tipo_registro = null
    this.vigencia = null
    this.vigencia_antiga = null
    this.tipo = null
    this.uf = null
    this.livro_caixa = false
    this.recolhimento = false    
    this.registro_oficial = null
    this.tipo_impresso_seguranca_personalizado = null
    this.notificar = null
    this.ativo = null
    this.itens = []
    this.created_at = null
    this.updated_at = null
    // Utilizado no front
    this.requiredSelo = false
    this.requiredImpresso = false
    
    if (data)  this.__init(data)
 
  }

  __init (data) {
    Object.assign(this, data)
    this.impresso()
    this.selo()
    if (data.itens) {
      this.itens = data.itens.map((destinatario) => new CustaDestinatario(destinatario))
    }
  }
  selo () {
    this.requiredSelo = !!selosFisicos.includes(this.tipo_ato)
  }
  impresso () {
    this.requiredImpresso = !!selosFisicos.includes(this.tipo_ato)
  }

  criaEstruturaDestinatarios (arr) {
    if (this.registro_oficial) return
    // Reseta valores antes de adicionar novamente
    this.itens = []
    for (const dest of arr) {
      if (dest.key) {
        this.itens.push(new CustaDestinatario({ destino: dest.key, tipo: dest.tipo, valor: 0}))
      }
    }
  }

  atualizaValorDestino (destino, valor) {
    console.log({destino, valor})
    if (this.registro_oficial || !destino || !valor) return
    for (const item of this.itens) {
      if (item.destino === destino) return item.valor = valor || 0
    }
  }
}

export default Custa